module.exports = __webpack_public_path__ + "img/account_2.8e381c63.png";